import React from 'react';
import { NotificationManager } from 'react-notifications';
import __isEmpty from 'lodash/isEmpty';

import './RequestForm.css';
import '../../components/elements/Textbox/TextboxWrapper.css';

import { sendPrivacyComplianceForm } from '../../services/parse';
import PageHeader from '../../components/global/PageHeader';
import Dropdown from '../../components/elements/Dropdown';
import Button from '../../components/elements/Button';

export default class PrivacyRequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      country: '',
      usState: '',
      description: '',
      request_type: '',

      countriesList: [],
      usStatesList: [],
    }

    this.request_types = [
      { value: '', text: 'Request Type*' },
      { value: 'Remove me from marketing emails and surveys', text: 'Remove me from marketing emails and surveys' },
      { value: 'Delete my personal info', text: 'Delete my personal info' },
    ];

    this.onChangeDropdown = this.onChangeDropdown.bind(this);
    this.setText = this.setText.bind(this);
  }

  componentDidMount() {
    //get the lists for countries and states
    fetch('https://thefoos-com2.s3.amazonaws.com/dashboard/locale/countries.json')
      .then(response => response.json())
      .then(countries => {
        countries.unshift({ name: 'Select Country of Residence*', code: '' });
        this.setState({ countriesList: countries });
    });

    fetch('https://thefoos-com2.s3.amazonaws.com/dashboard/locale/states.json')
      .then(response => response.json())
      .then(states => {
        states.unshift({ name: 'Select State*', code: '' });
        this.setState({ usStatesList: states });
    });
  }

  setText(name, value) {
    this.setState({ [name]: value });
  }

  onChangeDropdown(e) {
    switch(e.target.name) {
      case 'country':
        this.setState({ country: e.target.value });
        break;
      case 'usState':
        this.setState({ usState: e.target.value });
        break;
      case 'request_type':
        this.setState({ request_type: e.target.value });
        break;
      default:
        break;
    }
  }

  createMessageMarkup() {
    return `
      <html>
        <body>
          <div>
            <p style="padding: 0; margin: 0;">CCPA Compliance Request Form:</p>
            <br />
            <ul style="padding: 0; margin: 0;">
              <li style="margin: 0;">Name: <b>${ this.state.name }</b></li>
              <li style="margin: 0;">Email: <b>${ this.state.email }</b></li>
              <li style="margin: 0;">Country: <b>${ this.state.country }</b></li>
              <li style="margin: 0;">State (if applicable): <b>${ this.state.usState }</b></li>
              <li style="margin: 0;">Request Type: <b>${ this.state.request_type }</b></li>
            </ul>
            <p style="padding: 0; margin: 0;">Description:<br />${ this.state.description }</p>
          </div>
        </body>
      </html>
    `;
  }

  submitForm(e) {
    e.preventDefault();

    // check required fields
    if (__isEmpty(this.state.name)) {
        NotificationManager.error('Please fill out your name', '', 50000)
        return;
    } else if (__isEmpty(this.state.email)) {
        NotificationManager.error('Please fill out your email', '', 50000)
        return;
    } else if (__isEmpty(this.state.country)) {
        NotificationManager.error('Please select your country of residence', '', 50000)
        return;
    } else if (__isEmpty(this.state.request_type)) {
        NotificationManager.error('Please select your request type', '', 50000)
        return;
    }

    // clear the form once email has been sent
    sendPrivacyComplianceForm(this.createMessageMarkup()).then(() => {
      this.setState({
        name: '',
        email: '',
        country: '',
        usState: '',
        description: '',
        request_type: '',
      });
      NotificationManager.success('Your request has been sent and we will process it promptly. Thank you!', '', 5000)
    }).catch((error) => {
      NotificationManager.error('Uh oh, something went wrong and your request could not be sent. Please try again.', '', 50000)
    });
  }

  render() {
    return (
      <div className="privacy-request-form page">
        <PageHeader text="Personal Data Request Form" />
        <p className="required-text">* = required</p>
        <div className="grid-x grid-padding-x">
          <form id="privacy-form" onSubmit={ e => this.submitForm(e) }>
            <div className="small-12 cell">
              <div data-type="text" className="textbox-wrapper">
                <input
                  type="text"
                  placeholder="First and Last Name*"
                  name="name"
                  value={ this.state.name }
                  onChange={ (e) => this.setText('name', e.target.value) }
                />
              </div>
              <div data-type="text" className="textbox-wrapper">
                <input
                  type="text"
                  placeholder="Email address associated with codeSpark account*"
                  name="email"
                  value={ this.state.email }
                  onChange={ (e) => this.setText('email', e.target.value) }
                />
              </div>
              <Dropdown
                extraClass="dropdown"
                name="country"
                options={ this.state.countriesList }
                onChange={ this.onChangeDropdown }
                selectedValue={ this.state.country.value }
                specialKeys={ ['name', 'code'] }
              />
              { this.state.country === 'US' &&
                <Dropdown
                  extraClass="dropdown"
                  name="usState"
                  options={ this.state.usStatesList }
                  onChange={ this.onChangeDropdown }
                  selectedValue={ this.state.usState.value }
                  specialKeys={ ['name', 'code'] }
                />
              }
              <div data-type="text" className="textbox-wrapper">
                <textarea
                  placeholder="Description"
                  name="description"
                  value={ this.state.description }
                  onChange={ (e) => this.setText('description', e.target.value) }
                />
              </div>
              <Dropdown
                extraClass="dropdown"
                name="request_type"
                options={ this.request_types }
                onChange={ this.onChangeDropdown }
                selectedValue={ this.state.request_type }
              />
            </div>
            <Button text="Submit" />
          </form>
        </div>
        <div className="footer-buffer">
          <div className="form-info">Please use this form to contact the Privacy Team.
            If you prefer, you can also send us correspondence to:
            <p className="privacy-contact">
              codeSpark, Inc. <br />
              Attn: California Privacy Notice <br />
              130 W Union St., Pasadena, CA 91103
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PrivacyRequestForm/index.js